// CountryPosts.js  

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import LooksPost from './LooksPost';
import { Typography } from '@mui/material';
import './UsersPosts.css';

const CountryPosts = () => {
  const { country } = useParams();
  const { posts } = useContext(LooksPostsContext);
  const [countryPosts, setCountryPosts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (country && posts.length) {
      const filtered = posts.filter(
        (p) =>
          p.country === country &&
          !p.deleted &&
          !p.isReported &&
          (p.showOnHomePage || p.showInDiscoverBox)
      );
      setCountryPosts(filtered);
    }
  }, [country, posts]);

  return (
    <div className="users-posts-container">
      <h1>
        <span className="location-link">{country}</span>
      </h1>

      {countryPosts.length ? (
        countryPosts.map((post) => <LooksPost key={post.id} {...post} />)
      ) : (
        <Typography variant="body1" color="text.secondary">
          No posts found in this country.
        </Typography>
      )}
    </div>
  );
};

export default CountryPosts;
